import SectionCard from '@/components/base/SectionCard';
import StatusBadge from '@/components/base/StatusBadge';
import type { CreatorProfile } from '@/types/portal';

export default function AiFitPanel({ creator }: { creator: CreatorProfile }) {
  return (
    <SectionCard title="AI fit summary" subtitle="Why this creator surfaced for your brief">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-16 w-16 flex-col items-center justify-center rounded-lg bg-accent-100 text-accent-800">
            <span className="font-heading text-2xl font-bold leading-none">{creator.fitScore ?? '—'}</span>
            <span className="text-[9px] font-label uppercase tracking-wide">fit</span>
          </span>
          <div className="max-w-xs">
            <p className="text-sm text-foreground-700">
              {creator.fitScore != null
                ? 'Strong match on category, market and delivery history. Recommended for a performance-weighted allocation of the brief budget.'
                : 'No AI fit score yet for this creator.'}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <p className="mb-2 text-[11px] font-label font-semibold uppercase tracking-wider text-foreground-400">
            Match reasoning
          </p>
          <ul className="space-y-1.5">
            {creator.reasonCodes.length === 0 ? (
              <li className="text-sm text-foreground-500">No match reasoning available yet.</li>
            ) : null}
            {creator.reasonCodes.map((reason) => (
              <li key={reason} className="flex items-start gap-2 text-sm text-foreground-700">
                <i className="ri-check-double-line mt-0.5 text-accent-600" />
                {reason}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-2 text-[11px] font-label font-semibold uppercase tracking-wider text-foreground-400">
            Risk & watch items
          </p>
          {creator.riskFlags.length === 0 ? (
            <p className="flex items-center gap-2 text-sm text-accent-700">
              <i className="ri-shield-check-line" />
              No risk flags. Brand-safe and compliant.
            </p>
          ) : (
            <div className="flex flex-wrap gap-1.5">
              {creator.riskFlags.map((flag) => (
                <StatusBadge key={flag} status={flag} />
              ))}
            </div>
          )}
        </div>
      </div>
    </SectionCard>
  );
}